module.exports = __webpack_public_path__ + "img/logosd2.c2dcef43.png";